import React from 'react'
import './footer.css'

function Footer() {

    return (
        <div id='fademe-footer'>
            <div className='footer-container'>
                <h1 className='heaaa'>FOOTER</h1>
            </div>
        </div>
    )
}

export default Footer
